import React from 'react';

import tickIcon from '../../../assets/icons/invoice-confirmation/tick.svg';

export interface DiscountAppliedProps {
    code: string;
    discount: string;
    onRemove?: (code: string) => void;
}

const DiscountApplied: React.FC<DiscountAppliedProps> = ({ code, discount, onRemove }) => {
    return (
        <div className="w-full rounded-[4px] border border-[#D0D5DD] p-[16px] flex items-center justify-between bg-white h-[74px]">
            <div className="flex items-center gap-[10px]">
                {/* Tick Icon */}
                <div className="flex-shrink-0 w-[42px] h-[42px] flex items-center justify-center bg-gray-50 rounded-full">
                    <img src={tickIcon} alt="Applied" className="w-[20px] h-[20px] object-contain" />
                </div>

                {/* Text Content */}
                <div className="flex flex-col">
                    <span className="font-noto font-semibold text-[14px] leading-[24px] text-[#182230]">
                        {code} code applied
                    </span>
                    <span className="font-noto font-normal text-[12px] leading-[18px] text-[#667085]">
                        {discount}
                    </span>
                </div>
            </div>

            {/* Remove Button */}
            {onRemove && (
                <button
                    onClick={() => onRemove(code)}
                    className="w-[20px] h-[20px] flex items-center justify-center text-[#182230] hover:opacity-80 transition-colors focus:outline-none"
                    aria-label="Remove discount code"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            )}
        </div>
    );
};

export default DiscountApplied;
